import {useEffect, useState} from "react";

export function useDarkMode(): boolean {
    const [isDark, setIsDark] = useState<boolean>(
        window.matchMedia("(prefers-color-scheme: dark)").matches
    );
    useEffect(() => {
        const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
        const handleTheme = (e: any) => (e.matches ? setIsDark(true) : setIsDark(false));
        if (mediaQuery?.addEventListener) {
            mediaQuery.addEventListener("change", handleTheme);
        } else {
            //Fix older browser support
            mediaQuery.addListener(handleTheme);
        }
    }, []);
    return isDark;
}
